import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { CreateChancel, ValidationInput } from 'components';
import { httpRequestsOnErrorsActions, httpRequestsOnSuccessActions, resourceActions } from 'store';
import { FindLoad, useModal, FindSuccessItem, useGlobalTextStyles } from 'utils';

export const AddResource = ({ info, closeToSuccess }) => {
  const [name, setName] = useState('');
  const [error, setError] = useState(false);
  const ACTION_TYPE = info ? 'EDIT_RESOURCE' : 'CREATE_RESOURCE';
  const dispatch = useDispatch();
  const success = FindSuccessItem(ACTION_TYPE);
  const loader = FindLoad(ACTION_TYPE);
  const { close } = useModal();
  const globalText = useGlobalTextStyles();

  useEffect(() => {
    if (info) {
      const result = {
        ...info,
      };
      setName(result.name);
    }
  }, [info]);

  useEffect(() => {
    return () => {
      setError(false);
      dispatch(httpRequestsOnErrorsActions.removeError(ACTION_TYPE));
    };
  }, []);

  useEffect(() => {
    if (success) {
      dispatch(httpRequestsOnSuccessActions.removeSuccess(ACTION_TYPE));
      close();
      if (closeToSuccess) {
        closeToSuccess();
      }
    }
  }, [success]);

  const handleChangeName = (ev) => {
    setError(false);
    setName(ev.target.value);
  };

  const handleCreate = () => {
    const params = {
      name: name,
    };
    if (name) {
      if (info) {
        dispatch(resourceActions.editResource(info.id, params));
      } else {
        dispatch(resourceActions.createResource(params));
      }
    } else {
      setError(true);
    }
  };

  return (
    <div style={{ width: 532 }}>
      <p className={globalText.modalTitleWithMargin}>{info ? 'Edit Folder' : 'Add Folder'}</p>

      <div>
        <div className='modal-body-wrapper'>
          <div className='full-width'>
            <ValidationInput
              onChange={handleChangeName}
              label={'Folder Name*'}
              name={'name'}
              value={name}
              Length={40}
              typeError={error ? 'Folder name is required.' : ''}
              variant={'outlined'}
            />
          </div>
        </div>
        <CreateChancel
          width='100%'
          loader={!!loader.length}
          create={info ? 'Save' : 'Add'}
          chancel={'Cancel'}
          onClose={close}
          onCreate={handleCreate}
        />
      </div>
    </div>
  );
};